export default __webpack_public_path__ + "static/media/upoint.931d6003.png";